export default __webpack_public_path__ + "static/media/winfx.60afa169.wav";